import { NormalizeClubCardState, NormalizeCustomerCodeState } from './types'

export const normalizeCustomerCodeState = ({
  customerCodeType: codeType,
  customerCodeURL: codeImageUrl,
  customerLoyaltyId: codeNumber,
}): NormalizeCustomerCodeState => ({
  codeType,
  codeImageUrl,
  codeNumber,
})

export const normalizeClubCardState = ({
  pointsBalance: currentBalance,
  currentTier,
  nextTierBalance,
  currentTierCopy,
  nextTierCopyClubProfile,
  mainMembershipCardCopy,
}): NormalizeClubCardState => ({
  currentTier: parseInt(currentTier, 10),
  currentBalance: parseInt(currentBalance, 10),
  nextTierBalance: parseInt(nextTierBalance, 10),
  currentTierCopy,
  nextTierCopy: nextTierCopyClubProfile,
  mainMembershipCardCopy,
})

export default {
  normalizeCustomerCodeState,
  normalizeClubCardState,
}
